
import axiosInstance from "../mainService";
const operasionalService = {
    getOperasional(search, page, limit, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m139_operasionals/name/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllOperasional(search, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get('/count-data/m139_operasionals/name/' + sanitizedSearch + '/' + company);
    },
    deleteOperasional(id) {
        return axiosInstance.delete('/delete-data/m139_operasionals/' + id);
    },
    addOperasional(operasional) {
        return axiosInstance.post('/insert-data/m139_operasionals', operasional);
    },
    updateOperasional(operasional) {
        return axiosInstance.put(`/update-data/m139_operasionals/${operasional.id}`, operasional);
    },
}

export default operasionalService;